module.exports = __webpack_public_path__ + "media/start_game.d20a9c70.mp3";